import { j as C } from "./AccesRecoveryIcon-CUPieIxT.js";
const i = () => /* @__PURE__ */ C.jsxs("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ C.jsxs("g", { clipPath: "url(#clip0_10006_128746)", children: [
    /* @__PURE__ */ C.jsx(
      "path",
      {
        d: "M27.6303 38.4811C29.2527 37.8121 30.78 36.9325 32.1729 35.8651C33.2215 35.0588 34.1871 34.1501 35.0555 33.1524C34.2533 34.0385 33.2981 34.773 32.2357 35.3208C30.7581 36.0951 29.1082 36.482 27.4404 36.4452C25.7727 36.4084 24.1414 35.9492 22.6994 35.1106C21.8201 34.6051 21.0202 33.9727 20.3256 33.2337C20.0858 32.9848 19.8594 32.7233 19.6473 32.4504C19.0495 31.707 18.5066 30.9211 18.0229 30.0989C17.3304 28.9103 16.7622 27.6535 16.3273 26.3485C15.0938 22.6692 14.9577 18.7105 15.9356 14.9552C16.0509 14.516 16.1798 14.0803 16.3256 13.6463C13.9005 13.1547 11.4051 13.1179 8.96655 13.5378C7.50607 13.7767 6.11701 14.3374 4.89996 15.1793C3.68291 16.0212 2.66833 17.1231 1.9297 18.4054C1.12821 19.7912 0.672789 21.3499 0.602027 22.9492C0.542599 24.2622 0.742531 25.574 1.1904 26.8097L1.23619 26.9385C2.84987 31.3171 5.94931 34.9904 9.99411 37.3181C12.6474 38.8522 15.6182 39.7551 18.6765 39.9568C21.7348 40.1585 24.7985 39.6536 27.6303 38.4811Z",
        fill: "url(#paint0_linear_10006_128746)"
      }
    ),
    /* @__PURE__ */ C.jsx(
      "path",
      {
        d: "M32.1832 4.14136C30.7928 3.07022 29.2671 2.18717 27.6457 1.51511C26.4245 1.01204 25.1561 0.632071 23.8594 0.380859C25.028 0.631687 26.1417 1.09116 27.1472 1.73722C28.5549 2.63051 29.7132 3.86604 30.5138 5.32836C31.3145 6.79068 31.7313 8.43206 31.7254 10.0991C31.7273 11.1138 31.5799 12.1233 31.2879 13.095C31.1917 13.4261 31.0785 13.7521 30.9488 14.0716C30.6036 14.9605 30.1939 15.8229 29.7229 16.652C29.0397 17.8462 28.2357 18.9671 27.3235 19.9972C24.7552 22.9031 21.3972 24.9996 17.6585 26.0312C17.221 26.1516 16.7784 26.2584 16.3291 26.3483C17.1157 28.6945 18.3318 30.874 19.9154 32.7757C20.8527 33.9205 22.0329 34.8426 23.3704 35.4754C24.7079 36.1082 26.1694 36.4358 27.6491 36.4345C29.2503 36.4359 30.8282 36.0515 32.2493 35.3138C33.4164 34.7078 34.4533 33.8789 35.3015 32.8741L35.3897 32.7689C38.3754 29.1826 40.0071 24.6618 40.0001 19.9955C40.0018 16.9301 39.2976 13.9056 37.9421 11.1562C36.5865 8.40689 34.616 6.00658 32.1832 4.14136Z",
        fill: "url(#paint1_linear_10006_128746)"
      }
    ),
    /* @__PURE__ */ C.jsx(
      "path",
      {
        d: "M0.172973 17.373C-0.0576575 19.1128 -0.0576575 20.8754 0.172973 22.6153C0.344727 23.9252 0.647514 25.2145 1.07676 26.4639C0.708837 25.3263 0.549148 24.1317 0.605366 22.9374C0.680622 21.261 1.17711 19.6305 2.04899 18.1966C2.92087 16.7627 4.14003 15.5715 5.59389 14.7331C6.45844 14.2331 7.39289 13.8651 8.36626 13.6413C8.7022 13.5671 9.04179 13.5105 9.38363 13.4717C10.3334 13.3287 11.2922 13.2545 12.2526 13.2496C13.6285 13.2432 15.0013 13.379 16.3493 13.6549C20.1524 14.4271 23.6489 16.2885 26.4128 19.0124C26.735 19.3312 27.0487 19.6618 27.3505 20.006C28.9943 18.1547 30.2748 16.0105 31.125 13.6854C31.6397 12.2999 31.844 10.8184 31.7233 9.34538C31.6025 7.87237 31.1598 6.44382 30.4264 5.16067C29.6273 3.77317 28.5053 2.59891 27.1555 1.73756C26.048 1.03009 24.8122 0.547339 23.5184 0.316791L23.3827 0.291355C18.7788 -0.50473 14.0415 0.342646 9.99915 2.68532C7.34378 4.21526 5.07628 6.33587 3.37231 8.88287C1.66834 11.4299 0.573626 14.3349 0.172973 17.373Z",
        fill: "url(#paint2_linear_10006_128746)"
      }
    )
  ] }),
  /* @__PURE__ */ C.jsxs("defs", { children: [
    /* @__PURE__ */ C.jsxs(
      "linearGradient",
      {
        id: "paint0_linear_10006_128746",
        x1: "1.57532",
        y1: "18.8191",
        x2: "31.7592",
        y2: "36.1866",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ C.jsx("stop", { stopColor: "#0000FF" }),
          /* @__PURE__ */ C.jsx("stop", { offset: "0.75", stopColor: "#92E9FF" })
        ]
      }
    ),
    /* @__PURE__ */ C.jsxs(
      "linearGradient",
      {
        id: "paint1_linear_10006_128746",
        x1: "23.8339",
        y1: "35.1409",
        x2: "34.2821",
        y2: "5.10876",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ C.jsx("stop", { stopColor: "#0000FF" }),
          /* @__PURE__ */ C.jsx("stop", { offset: "0.75", stopColor: "#79FC9C" })
        ]
      }
    ),
    /* @__PURE__ */ C.jsxs(
      "linearGradient",
      {
        id: "paint2_linear_10006_128746",
        x1: "31.3233",
        y1: "8.55156",
        x2: "0.254657",
        y2: "15.2059",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ C.jsx("stop", { stopColor: "#0000FF" }),
          /* @__PURE__ */ C.jsx("stop", { offset: "0.75", stopColor: "#FF91D1" })
        ]
      }
    ),
    /* @__PURE__ */ C.jsx("clipPath", { id: "clip0_10006_128746", children: /* @__PURE__ */ C.jsx("rect", { width: "40", height: "40", fill: "white" }) })
  ] })
] });
export {
  i as T
};
